import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useHistory } from "react-router-dom";

import sliderImage from '../assets/img/slider.png'

import left from '../assets/img/left.png'
import right from '../assets/img/right.png'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const data = [
  { imgPath: sliderImage},
  { imgPath: sliderImage },
  { imgPath: sliderImage },
];

const Slider = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = data.length;
  let history = useHistory();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const toToLogin = () => {
    // window.location.href='/login'
    history.push("/login");
  }

  return (
    <div className="slider">
      <div className="slider__item">
          <AutoPlaySwipeableViews index={activeStep} onChangeIndex={handleStepChange} enableMouseEvents>
            {data.map((step, index) => (
              <div key={`slider-${index}`}>
                {Math.abs(activeStep - index) <= 2 ? (
                    // <img className="img" src={step.imgPath} alt={step.label} />
                    <div className="img" style={{ backgroundImage: `url(${step.imgPath})` }}></div>
                ) : null}
              </div>
            ))}
          </AutoPlaySwipeableViews>
      </div>
      <div className="slider__item slider__item--overlay">
        <div className="title">Event Title</div>
        <div className="sub-title">21-05-01</div>
        <div className="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</div>
        <div><button className="btn" onClick={toToLogin}>Register Now</button></div>
      </div>
      <div className="control">
        <button onClick={handleBack} disabled={activeStep === 0}> <img src={left} alt="left" /> </button>
        <button onClick={handleNext} disabled={activeStep === maxSteps - 1}><img src={right} alt="right" /></button>
      </div>
      <div className="state">
        {data.map((step, index) => (
          <div key={`slide-state-${index}`}>
            <div className="state__item" style={{ backgroundColor: index === activeStep ? 'red' : '#fff' }}></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Slider;
